import IconSvg from 'src/assets/icons/IconSvg';

interface Props {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({ currentPage, totalPages, onPageChange }: Props) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = (): (number | '...')[] => {
    const pages: (number | '...')[] = [];
    const delta = 1;

    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    return pages;
  };

  return (
    <div className="flex gap-2 justify-center items-center mt-6">
      <button
        className="p-2 rounded-lg bg-grayscale-800 text-grayscale-400 disabled:opacity-30 transition-colors hover:bg-grayscale-700"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <IconSvg icon="arrowLeftS" />
      </button>

      {getPageNumbers().map((page, idx) =>
        page === '...' ? (
          <span key={`ellipsis-${idx}`} className="px-2 text-grayscale-500">
            ...
          </span>
        ) : (
          <button
            key={page}
            className={`w-9 h-9 rounded-lg text-sm font-medium transition-colors ${
              currentPage === page
                ? 'bg-brand-tangerine text-brand-black'
                : 'bg-grayscale-800 text-grayscale-400 hover:bg-grayscale-700'
            }`}
            onClick={() => onPageChange(page as number)}
          >
            {page}
          </button>
        ),
      )}

      <button
        className="p-2 rounded-lg bg-grayscale-800 text-grayscale-400 disabled:opacity-30 transition-colors hover:bg-grayscale-700"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <IconSvg icon="arrowRightS" />
      </button>
    </div>
  );
};

export default Pagination;
